import { createRouter, createWebHistory } from 'vue-router'

import SearchView from '../views/SearchView.vue'
import SearchVin from '../views/SearchVin.vue'
import AuctionView from '../views/AuctionView.vue'
import Iframe from '../views/Iframe.vue'
import CacheManager from '../views/CacheManager.vue'

import SiteLayout from '../components/SiteLayout.vue'
import { sitePages } from '../views/site'

const APP_PATHS = ['/iframe', '/search', '/search_vin', '/auction', '/admin']

const routes = [
  {
    path: '/',
    component: SiteLayout,
    // Every japoniacars.pl page, on the path it has on the live site, inside
    // the shared header/footer chrome. Children are relative to the '/'
    // parent, so '/o-nas/' becomes 'o-nas/'.
    children: sitePages.map((page) => ({
      ...page,
      path: page.path.replace(/^\//, ''),
    })),
  },

  // Standalone (chrome-less) app routes. These are what japoniacars.pl used to
  // embed as iframes; they stay reachable so the existing embeds keep working
  // while the WordPress site is retired.
  { path: '/iframe', name: 'iframe', component: Iframe },
  { path: '/search', name: 'search', props: true, component: SearchView },
  { path: '/search_vin', name: 'search_vin', props: true, component: SearchVin },
  { path: '/auction/:id', name: 'auction', component: AuctionView },
  { path: '/admin/cache', name: 'cache-manager', component: CacheManager },

  // WordPress served every page with a trailing slash; accept the bare form too.
  {
    path: '/:pathMatch(.*)*',
    redirect: (to) => {
      const path = to.path
      const isAppPath = APP_PATHS.some(
        (p) => path === p || path.startsWith(p + '/')
      )
      if (!isAppPath && !path.endsWith('/')) {
        return { path: path + '/', query: to.query, hash: to.hash }
      }
      return { path: '/' }
    },
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  // Without this, /o-nas would render the page as well as /o-nas/ — two URLs
  // for one page. Strict matching sends the bare form through the redirect
  // above instead.
  strict: true,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition
    if (to.hash) return { el: to.hash, behavior: 'smooth' }
    // Changing filters re-uses the same path; don't yank the user to the top.
    if (to.path === from.path) return false
    return { top: 0 }
  },
})

export default router
